import {beginPurchase} from './pbc-core-browser-ae0ae8475392.js';
import {PRODUCTS} from './pbc-core-engine-d25064206509.js';
// Entry adapter touches only explicit supported product purchase actions.
// It never intercepts networking preview, arbitrary form, or free opt-in submissions.
const local=['localhost','127.0.0.1','::1'].includes(location.hostname);
const enabled=local||(location.hostname==='prodbycamm.com'&&document.documentElement.dataset.upsells==='enabled');
if(enabled){
 let pending=false;
 function product(id){return Object.values(PRODUCTS).find(p=>p.variant===Number(id));}
 async function purchase(p,control){
  if(pending)return;pending=true;const text=control.textContent;control.setAttribute('aria-disabled','true');
  let status=document.querySelector('[data-purchase-status]');
  if(!status){status=document.createElement('p');status.dataset.purchaseStatus='';status.setAttribute('role','status');status.style.cssText='position:fixed;bottom:16px;left:16px;right:16px;z-index:9999;background:#15131d;color:white;padding:16px;border:1px solid #b712de;border-radius:12px';document.body.appendChild(status);}
  status.textContent=local?'Adding to your preview cart…':'Adding to your cart…';
  try{await beginPurchase(p.handle);}catch(error){status.textContent=error.message;control.textContent=text;/* Uncertain write: require cart review before retry. */}
 }
 document.addEventListener('click',e=>{
  const a=e.target.closest('a[href]');if(!a)return;const url=new URL(a.href,location.href);if(url.origin!==location.origin||url.pathname!=='/cart/add')return;
  const p=product(url.searchParams.get('id'));if(!p)return;e.preventDefault();e.stopImmediatePropagation();purchase(p,a);
 },true);
 document.addEventListener('submit',e=>{
  const form=e.target;if(!(form instanceof HTMLFormElement))return;const url=new URL(form.action,location.href);if(url.origin!==location.origin||url.pathname!=='/cart/add')return;
  const p=product(new FormData(form).get('id'));if(!p)return;e.preventDefault();e.stopImmediatePropagation();purchase(p,e.submitter||form.querySelector('button'));
 },true);
}
